import $ from 'jquery';
import layout from '../Layout';
import Flickity from 'flickity';
import 'flickity-imagesloaded';
import debounce from 'just-debounce';
import imagesLoaded from 'imagesloaded';
import ProductForm from './ProductForm';

export default class ProductDetails {
  constructor($el, section) {
    this.data = section.data;

    this.$el = $el;
    this.$window = $(window);
    this.$productImages = $('[data-product-images]', $el);
    this.$productImageItems = $('[data-product-image]', $el);
    this.productImagesCount = this.$productImageItems.length;
    this.$productDetails = $('[data-product-details]', $el);
    this.$menu = $('[data-product-menu-container]', $el);

    this.positionDetails = this._positionDetails.bind(this);

    // Alert
    this.$alert = $('.product-alert');

    // Form
    if (this.data.form_is_inline) {
      this.form = new ProductForm(this.$el.find('[data-product-form-inline]'), {
        container: '[data-product-details]',
        product: this.data.product,
        moneyFormat: this.data.money_format,
        postMessage: section.postMessage,
        useHistory: true,
        onAddToCart: () => this._hideAlert(),
        onSuccess: (response, quantity) => this._onAtcSuccess(response, quantity),
        onError: (response, error) => this._onAtcError(response, error),
        onVariantChange: (variant) => this._onVariantChange(variant),
      });

      this._onVariantChange(this.form.variantHelper.getSelectedVariant());
    }

    // Handle image loads
    if (this.productImagesCount > 0) {
      this.imagesLoaded = new imagesLoaded(this.$productImages[0]);
      this.imagesLoaded.on('progress', this.positionDetails);
    }

    // Handle layout changes
    this.onLayoutChange = event => this._layout();
    layout.onBreakpointChange(this.onLayoutChange);

    // Initial positioning
    this._layout();

    // Events
    this.events = [
      // Dismiss alert
      this.$alert.find('.product-alert-dismiss').on('click.product', event => this._hideAlert()),
    ];
  }

  unload() {
    this._destroyFlickity();
    this.$window.off('.product-details');
    layout.offBreakpointChange(this.onLayoutChange);
    this.hideAlert();

    if (this.form) this.form.unload();
    if (this.imagesLoaded) this.imagesLoaded.off(this.positionDetails);
  }

  _layout() {
    if (layout.isBreakpoint('L')) {
      this._destroyFlickity();
      this.$window.on('resize.product-details', this.positionDetails);
    } else {
      this._initFlickity();
      this.$window.off('resize.product-details');
    }

    this._positionDetails();
  }

  _positionDetails() {
    if (layout.isBreakpoint('L')) {
      const imagesHeight = this.$productImages.outerHeight();
      const detailsHeight = this.$productDetails.outerHeight();
      const windowHeight = window.innerHeight;
      const menuHeight = this.$menu.outerHeight() || 0;
      const availableHeight = windowHeight - menuHeight;

      this.isSticky =
        imagesHeight > availableHeight &&
        detailsHeight < availableHeight;
    } else {
      this.isSticky = false;
    }

    this.$productDetails.toggleClass('product-details-sticky', this.isSticky);
  }

  // Show correct image for the selected variant
  selectVariantImage(variant) {
    if (!variant || !variant.featured_image) return;

    // Grab selected image element
    const $productImage = $(`[data-product-image-id="${variant.featured_image.id}"]`, this.$el);
    if (!$productImage) return;

    // Change slideshow slide if we are in mobile
    if (this.flickity) {
      const index = $productImage.data('product-image-index');
      this.flickity.select(index, false, false);
      return;
    }

    // Move image to top if we are not in sticky mode
    if (!this.isSticky) {
      $productImage.prependTo(this.$productImages);
    }

    // Fade out non-selected images
    this.$productImageItems
      .not($productImage)
      .addClass('product-image-fade');

    // Scroll to selected image
    const scrollTop = this._getVariantScrollPosition(variant, $productImage);

    $('html,body').animate({ scrollTop }, 'slow', 'swing', () => {
      // Fade back in all the images
      setTimeout(() => {
        this.$productImageItems.removeClass('product-image-fade');
      }, 333);
    });
  }

  _getVariantScrollPosition(variant, $image) {
    // If we are not in sticky mode, just scroll to the top of the page
    if (!this.isSticky) return 0;

    // Otherwise, scroll to the selected image
    const menuHeight = this.$menu.height() || 0;

    // Bottom of the image list
    const max = this.$productImages.outerHeight()
      + this.$productImages.offset().top
      + menuHeight
      - window.innerHeight;

    // Image mid-point
    const imageOffset = $image.offset().top
      - ((window.innerHeight - menuHeight) / 2)
      + ($image.height() / 2)

    // Don't scroll past the bottom image
    return Math.min(max, imageOffset);
  }

  _initFlickity() {
    if (this.productImagesCount < 2) {
      return;
    }

    // Reintroduce Flickity adaptive height (featured in v2.0.0 but not v1.2.1)
    Flickity.prototype.setGallerySize = function() {
      if ( this.options.setGallerySize ) {
        const height = this.options.adaptiveHeight && this.selectedCell ?
          this.selectedCell.size.outerHeight : this.maxCellHeight;
        this.viewport.style.height = height + 'px';
      }
    };

    const select = Flickity.prototype.select;
    Flickity.prototype.select = function() {
      select.apply( this, arguments );
      if ( this.options.adaptiveHeight ) {
        this.setGallerySize();
      }
    };

    if (!this.flickity) {
      this.flickity = new Flickity(this.$productImages[0], {
        accessibility: true,
        adaptiveHeight: true,
        cellAlign: 'left',
        cellSelector: '[data-product-image]',
        friction: 0.8,
        imagesLoaded: true,
        pageDots: false,
        prevNextButtons: false,
        selectedAttraction: 0.2,
        wrapAround: true,
      });
    }
  }

  _destroyFlickity() {
    if (this.flickity) {
      this.flickity.destroy();
      this.flickity = null;
      $('[data-product-image]', this.$el).attr('style', '');
    }
  }

  _onAtcSuccess(response, quantity) {
    this._showAlert(this.data.text.added_to_cart_link);
  }

  _onAtcError(response, error) {
    this._showAlert(error, 'error');
  }

  _onVariantChange(variant) {
    this.$el.find('.product-form-inline-atc-button')
      .prop('disabled', !variant.available)
      .text(variant.available
        ? this.data.text.product_available
        : this.data.text.product_unavailable
      );
  }

  _showAlert(message, type = null) {
    this._hideAlert();

    // Add class name
    if (type) {
      this.alertClassName = `product-alert-${type}`;
      this.$alert.addClass(this.alertClassName);
    }

    // Set text
    const $message = this.$alert.find('.product-alert-message');
    $message.html(message);
    this.$alert.one('revealer-hide', event => $message.text(''));

    // Show
    this.$alert.revealer('show');

    // Positioning
    this._positionAlert();
    $(window).on('scroll.product-alert', event => this._positionAlert());
  }

  _hideAlert() {
    // Remove custom class names
    this.$alert.removeClass(this.alertClassName);
    this.alertClassName = null;

    // Stop positioning
    $(window).off('scroll.product-alert');

    // Hide
    this.$alert.revealer('hide');
  }

  _positionAlert() {
    const top = this.$el.offset().top;
    const scroll = document.body.scrollTop;
    this.$alert.toggleClass('product-alert-fixed', scroll >= top);
  }
}
